import { render, staticRenderFns } from "./SettingIcon.vue?vue&type=template&id=4bbcf2f2&scoped=true&"
import script from "./SettingIcon.vue?vue&type=script&lang=js&"
export * from "./SettingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbcf2f2",
  null
  
)

export default component.exports